import React, {FC, memo} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';

/*
 * Props.
 */

interface CommentHeaderIconProps {
  iconName: IconName;
  backgroundColor: string;
}

/*
 * Constants.
 */

const circleSize = 16;
const iconSize = 12;

export const commentHeaderIconWidth = circleSize;

/*
 * Styles.
 */

interface CircleSpanStyleProps {
  $backgroundColor: string;
}

const StyledCircleSpan = styled.span<CircleSpanStyleProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${(p) => p.$backgroundColor};
  width: ${circleSize}px;
  height: ${circleSize}px;
`;

/*
 * Component.
 */

export const CommentHeaderIcon: FC<CommentHeaderIconProps> = memo((props) => {
  const {iconName, backgroundColor} = props;

  return (
    <UserThemeConsumer>
      {(theme) => (
        <StyledCircleSpan $backgroundColor={backgroundColor}>
          <Icon name={iconName} size={iconSize} color={theme.greys.white} />
        </StyledCircleSpan>
      )}
    </UserThemeConsumer>
  );
});
